import URI from "urijs";

export function wordEllipsis(str = "", n) {
  let strCut = str.substring(0, n);
  return str.length <= n ? str : strCut.substring(0, strCut.lastIndexOf(" ")) + "...";
}

export function slugToCountryPathname(slug) {
  const availableCountries = ["sg", "my"];
  const uri = new URI(window.location.href);
  const currentUrlCountry = uri.segment(0);
  const countryCode = availableCountries.includes(currentUrlCountry)
    ? currentUrlCountry
    : localStorage.getItem("country");
  return `/${countryCode.toLowerCase()}/${slug}`;
}

export function removeTrailingSlash(str) {
  return str.replace(/^(.+?)\/*?$/, "$1");
}

export function padStartPolyfill({ content, targetLength, padString }) {
  content = content !== undefined && content !== null ? content.toString() : " ";
  padString = padString !== undefined ? padString : " ";
  targetLength = parseInt(targetLength || 0, 10);
  const currentLength = content.length;
  if (currentLength >= targetLength) return content;
  targetLength = targetLength - currentLength;
  if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length);
  return padString.slice(0, targetLength) + content;
}

export function replaceAllVariables(json, variables) {
  let string = JSON.stringify(json);
  const regex = /(\${\s?([^}]*)\s?})/g;
  const matches = Array.from(new Set(string.match(regex)));

  if (matches) {
    const cleanVariables = matches.map(match => match.slice(2, -1).trim());
    const filteredVariables = variables.filter(variable => cleanVariables.includes(variable.name));

    filteredVariables.forEach(variable => {
      const regexColon = new RegExp(String.raw`:\${\s?${variable.name}\s?}`, "g");
      string = string.replace(regexColon, `:${variable.value.replace(/\s+/g, "")}`);
      const regexParenthesis = new RegExp(String.raw`\(\${\s?${variable.name}\s?}\)`, "g");
      string = string.replace(regexParenthesis, `(${variable.value.replace(/\s+/g, "")})`);
      const regexClassic = new RegExp(String.raw`\${\s?${variable.name}\s?}`, "g");
      string = string.replace(regexClassic, variable.value);
    });
  }
  return JSON.parse(string);
}

export const validPath = path => (path.includes("http") ? path : slugToCountryPathname(path || ""));
